export const BASE_URL = import.meta.env.VITE_APP_BACKEND ?? '/'
export const AUTH_LOGIN_PATH = '/auth/login'
export const AUTH_FORGOT_PASSWORD_REQUEST_PATH = '/auth/forgot-password'
export const AUTH_RESET_PASSWORD_REQUEST_PATH = '/auth/reset-password'
export const AUTH_PROFILE_PATH = '/auth/profile'
export const CURRENT_USER_PATH = '/users/get_current_user'
export const USER_PATH = '/users'
export const ADMINISTRATOR_PATH = '/users/administrators'
export const CUSTOMER_PATH = '/users/customers'
export const OPERATOR_PATH = '/users/operators'
export const ADDITIONAL_EMAIL_PATH = '/additional_emails'
export const DEVICE_PATH = '/devices'
export const REGISTER_PATH = '/registers'
export const REQUEST_PATH = '/requests'
export const TRANSMISSION_PATH = '/transmissions'
export const DEVICE_ANOMALY_PATH = '/device_anomalies'
export const NOTE_PATH = '/notes'
export const CUSTOMS_OFFICE_PATH = '/customs_offices'
export const FILTER_PATH = '/filters'
